export enum AppName {
    auto = 'auto',
    esports = 'esports',
    handball = 'handball',
    sportdeutschland = 'sportdeutschland',
    tischtennis = 'tischtennis',
    turn = 'turn'
}
